import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { deletePromoCampaign } from '~/services/LuxLoyalty';

import { promoCampaignQueryKeys } from './promoCampaignQueryKeys';

interface DeletePromoCampaignParams {
  promoCampaignId: string;
}

export function useDeletePromoCampaign() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async ({ promoCampaignId }: DeletePromoCampaignParams) => {
      return await deletePromoCampaign(promoCampaignId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: promoCampaignQueryKeys.all });
      enqueueSnackbar('Campaign deleted successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to delete campaign: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
